import script from "./Billing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Billing.vue?vue&type=script&setup=true&lang=ts"

import "./Billing.vue?vue&type=style&index=0&id=25fede8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25fede8e"]])

export default __exports__